export default __webpack_public_path__ + "static/media/search.80cca22e.png";